import { OneUpIcon } from './OneUpIcon';

/**
 * author: Michael Irigoyen
 * id DF8CCF67-8BD2-4632-8647-2B42BA2047A5
 * name one-up
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/one-up.svg
 * tags
 * - Gaming / RPG 
 */
export const _1upIcon = OneUpIcon;
export default _1upIcon